import { removeHtmlTagsAndEntities } from "../../../../../../utils/helpers";

export function getTaggedUserIds(selectedIds, users, comment) {
  return [...new Set(
    selectedIds.filter((userId) =>
      users.some(
        (user) =>
          user?.user_id === userId &&
          comment?.toLowerCase()?.includes(user?.username?.toLowerCase())
      )
    )
  )];
}

export function getEditorCommentValue(editorRef) {
  return removeHtmlTagsAndEntities(editorRef?.current?.value)?.trim();
}

export function sortByDateDescending(items = [], fieldName) {
  return [...items].sort(
    (left, right) => new Date(right?.[fieldName]) - new Date(left?.[fieldName])
  );
}
